import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { BlocksContent, BlocksRenderer } from "@strapi/blocks-react-renderer";
import { Slash } from "lucide-react";

export interface PrivacyProps {
  content: BlocksContent;
  updatedAt: string;
}

export default function PrivacyContent(props: PrivacyProps) {
  return (
    <div className="bg-coffebrown w-full">
      <div className="w-full xl:max-w-screen-xl mx-auto px-8 xl:px-0 pt-20 xl:pt-44">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink
                className="font-karbon xl:text-2xl text-white"
                href="/"
              >
                Home
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator>
              <Slash className="text-white" />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbLink
                className="font-karbon xl:text-2xl text-white"
                href="/privacy-policy"
              >
                Term and Conditions
              </BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <p className="text-gold font-pluto text-3xl xl:text-5xl mt-12">
        Privacy Policy
        </p>

        <p className="text-white font-karbon mt-4 mb-20 xl:text-[1.75rem]">
          Last modified on {props.updatedAt}
        </p>

        <div className="whitespace-normal text-white font-karbon xl:text-2xl pb-44 revert-all">
          <BlocksRenderer content={props.content} />
        </div>
      </div>
    </div>
  );
}
